export default "__VITE_ASSET__CEDAsQDf__"